import React, { useState } from 'react';
import { useForm, ValidationError } from '@formspree/react';

export const Booking = () => {

    const [state, handleSubmit] = useForm("xvojodwp");

    const [inputValue, setInputValue] = useState('');
    const [inputValueSecond, setInputValueSecond] = useState('');
    const [inputValueThird, setInputValueThird] = useState('');

    const handleInputChange = (event) => {
        setInputValue(event.target.value);
    };

    const handleInputSecond = (event) => {
        setInputValueSecond(event.target.value);
    };

    const handleInputThird = (event) => {
        setInputValueThird(event.target.value);
    };
  
    const handleClearClick = () => {
        setTimeout(() => {
            setInputValue('');
            setInputValueSecond('');
            setInputValueThird('');
        
        }, 1000)
    };
  

    return (
        <section id="Booking">
        <div className='One-bl'>
            <form onSubmit={handleSubmit}>
                <div className='item-bl-form'>
                    <h3>Contact us</h3>
                </div>

                <div className='item-bl-form'>
                    <label htmlFor="email">Email Address</label>
                    <input id="email" type="email" name="Email" value={inputValue} onChange={handleInputChange} required />
                    <ValidationError prefix="Email" field="Email" errors={state.errors}/>
                </div>

                <div className='item-bl-form'>
                    <label htmlFor="phone">Phone Number</label>
                    <input id="phone" type="tel" name="Number Phone" value={inputValueSecond} onChange={handleInputSecond} />
                    <ValidationError prefix="Phone" field="Number Phone" errors={state.errors}/>
                </div>

                <div className='item-bl-form'>
                    <label htmlFor="message">Your Message</label>
                    <textarea id="message"name="Message" value={inputValueThird} onChange={handleInputThird} required/>
                    <ValidationError prefix="Message" field="Message" errors={state.errors} />
                </div>
                    
                <div className='item-bl-form'>
                    <button type="submit" disabled={state.submitting} onClick={handleClearClick}>Submit</button>
                </div>
                   
            </form>
        </div>

        <div className='two-bl'>
            <div className='border-bl-two'>
            </div>
            
        </div>

        </section>
    );
}